<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>脚本调试</span>
        </div>
      </div>
      <div class="coreMain" style="padding-top: 10px;">
        <el-card class="box-card">
          <script-debug-component :initVal="initVal" :script="script" @changeScript="changeScript"></script-debug-component>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "../../api/api";
  import scriptDebugComponent from '../../components/scriptDebugComponent'
  export default {
    components: {
      scriptDebugComponent
    },
    data() {
      return {
        script:'',
        initVal:''
      }
    },
    created() {},
    methods: {
      changeScript(scriptText){
        this.script= scriptText
      },
    },
    mounted() {

    },
  }

</script>



// WEBPACK FOOTER //
// src/views/platform/scriptDebug.vue